import { useMemo } from 'react'
import { generatePath } from 'react-router'

import { MODULES } from 'portal/lib/constants'
import { NavButtonDecorator } from 'portal/lib/primitives'

import {
  WASTE_RECORD_LINE_ITEM_EDIT,
  DELIVERY_RECORD_LINE_ITEM_EDIT
} from 'portal/routes'
import { AddButton } from './AddButton'
import { useModuleIds } from 'portal/lib/hooks'

export function AddLineItemButton() {
  const { accountId, projectId, recordId, moduleName } = useModuleIds()

  const uri = useMemo(() => {
    return MODULES.select(moduleName, {
      delivery: () =>
        generatePath(DELIVERY_RECORD_LINE_ITEM_EDIT, {
          accountId,
          projectId,
          recordId,
          moduleName,
          lineItem: 'new'
        }),
      waste: () =>
        generatePath(WASTE_RECORD_LINE_ITEM_EDIT, {
          accountId,
          projectId,
          recordId,
          moduleName,
          lineItem: 'new'
        })
    })
  }, [accountId, moduleName, projectId, recordId])

  return (
    <NavButtonDecorator to={uri}>
      <AddButton id="AddLineItemButton">Add item</AddButton>
    </NavButtonDecorator>
  )
}
